import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FranchiseHomeBanner from "./component";
import { checkForUserInterest, fetchCMSData } from "./actions";

const mapStateToProps = ({
    meta: { genericContent, mainHeading, isSSR },
    user: { isLoggedIn, secureToken },
    franchise: { faqList }
}) => ({
    genericContent,
    mainHeading,
    isLoggedIn,
    isSSR,
    secureToken,
    faqList
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    checkForUserInterestConnect: checkForUserInterest,
    fetchDataConnect: fetchCMSData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FranchiseHomeBanner);
